// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Injectable, Component } from '@angular/core';
import { AppComponent } from 'src/app/app.component'
import {createDiscardDialog} from '../app/guards/page.guard';
import { MatDialog } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class PageDeactivateService  {

  // This value is only used if the canDeactivateUserSelector() method is called.
  lastUserSelected = null;

  constructor(private readonly dialog: MatDialog, private readonly translate: TranslateService) {
  }

  // On pages that honor the user selector and have to detect a Selected User change,
  // this method can be used in the subscribe method to pop up the Stay or Discard message
  // and set the User Selector back to all if Stay is selected.
  // Inside the constructor of the page add code similar to:
  //
  // this.rjxSubscriptions.add(
  //   this.headerService.userSelectedChanged.subscribe(value => {
  //     this.selectedOrgId = value;  // or some other way to keep the value!
  //     pageDeactivateService.canDeactivateUserSelector(this, this.appComponent);
  //   })
  // );
  //
  // The page must implement the userValueChanged() method, which will be called
  // if the user says discard, or if the page is not dirty. 
  // Note: that the userValueChanged() method should reset the dirty flag.
  //
  // An example can be found in the global-d3e-policy.component.ts.
  //

  canDeactivateUserSelector(component, appComponent: AppComponent): void {
    if (component.getIsDirty()) {
      if (this.lastUserSelected !== appComponent.selectedOrgId) {
        // we only want to check this if the user isn't the same, if the user
        // is the same we have "changed it back"
        this.lastUserSelected = appComponent.lastAllUsersId;
        createDiscardDialog(this.dialog, this.translate).subscribe(result => {
          if (result) {
            this.lastUserSelected = null;
            component.userValueChanged();
          } else {
            appComponent.orgSelectChanged(this.lastUserSelected);
          }
        });
      }
    } else {
      this.lastUserSelected = null;
      component.userValueChanged();
    }
  }
}
